import PropTypes from "prop-types";
import React from "react";
import { components } from "react-select";
import { Badge } from "reactstrap";

const SingleColorSelect = ({ ...props }) => {
  return (
    <React.Fragment>
      {/* @ts-ignore */}
      <components.SingleValue {...props}>
        <div className="d-flex justify-content-between align-items-center">
          <div>{props.children}</div>
          <Badge color={String(props?.data?.value || "")}>
            <div style={{ color: "transparent" }}>{"-----"}</div>
          </Badge>
        </div>
      </components.SingleValue>
    </React.Fragment>
  );
};

SingleColorSelect.propTypes = {
  selectProps: PropTypes.any,
  children: PropTypes.any,
  options: PropTypes.any,
  value: PropTypes.any,
  data: PropTypes.any,
};

export default SingleColorSelect;
